var React = require('react');

function MultiplePipelineIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0h11l2.002 5.059L17 10.118H6l2.002-5.06L6 0zm14 0h11l2.002 5.059L31 10.118H20l2.002-5.06L20 0zm14 0h11l2.002 5.059L45 10.118H34l2.002-5.06L34 0zm-4 14h11l2.002 5.059L41 24.118H30l2.002-5.06L30 14zm-15 0h11l2.002 5.059L26 24.118H15l2.002-5.06L15 14zM0 14h11l2.002 5.059L11 24.118H0l2.002-5.06L0 14zm6 14h11l2.002 5.059L17 38.118H6l2.002-5.06L6 28zm14 0h11l2.002 5.059L31 38.118H20l2.002-5.06L20 28zm14 0h11l2.002 5.059L45 38.118H34l2.002-5.06L34 28z","fillRule":"evenodd"}));
}

MultiplePipelineIcon.defaultProps = {"viewBox":"0 0 47 39"};

module.exports = MultiplePipelineIcon;

MultiplePipelineIcon.default = MultiplePipelineIcon;
